import { useState, useEffect, useCallback } from 'react';
import { api } from '@/lib/api';
import type { Preset } from '@/types';

export function usePresets(category?: string) {
  const [presets, setPresets] = useState<Preset[]>([]);
  const [categories, setCategories] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPresets = useCallback(async () => {
    try {
      setIsLoading(true);
      const data = await api.getPresets(category);
      setPresets(data.presets);
      setCategories(data.categories);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load presets');
    } finally {
      setIsLoading(false);
    }
  }, [category]);

  useEffect(() => {
    fetchPresets();
  }, [fetchPresets]);

  return { presets, categories, isLoading, error, refresh: fetchPresets };
}

